<div class="cmp-root" (pointerdown)="$event.stopPropagation()">
  <div class="label">operator</div>
  <select class="select" [value]="data.op" (change)="change(($any($event.target)).value)">
    <option value="==">==</option>
    <option value="!=">!=</option>
    <option value="<">&lt;</option>
    <option value="<=">&lt;=</option>
    <option value=">">&gt;</option>
    <option value=">=">&gt;=</option>
    <option value="in">in</option>
    <option value="not in">not in</option>
    <option value="and">and</option>
    <option value="or">or</option>
  </select>
</div>

